module.exports = __webpack_public_path__ + "img/banner-6-th.c92d1e68.jpg";